export const environment = {
  production: false,
  STATIONS_API_URL: 'https://api.seatfrog-backend-staging.com/stations',
  FLEX_API_URL: 'https://api.seatfrog-backend-staging.com/flex',
  CLIENT_CODE: 'vtweb',
  VALIDATE_MERCHANT_URL: 'https://api.seatfrog-backend-staging.com/payments/apple-pay/validate-merchant',
  APPLE_PAY_MERCHANT_ID: 'merchant.com.adyen.seatfrog-dev',
  APPLE_PAY_DISPLAY_NAME: 'Avanti Superfare UAT',
};